import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { FileToUpload, UserUploadDoc } from "../../../models/";
import { ConfigService } from '../../config.service';

import { HeaderFactoryService } from "../../header-factory.service";

@Injectable()
export class FileUploadService {
  webApiUrl: string;
  API_URL :String;
  httpOptions = {
    headers: new HttpHeaders({
      Accept: "application/csv"
      // Authorization: "my-auth-token"
    })
  };

  constructor(private configService: ConfigService,
    private httpsClient: HttpClient, private headerService: HeaderFactoryService,
   ) {
      this.API_URL =  `${this.configService.apiUrl}api/v${this.configService.apiVersion}/`;
  }

  // Call uoload template API
  uploadFile(theFile: FileToUpload): Observable<any> {
    return this.httpsClient.post<FileToUpload>(
      this.API_URL + "profile/uploadtemplate", theFile, this.headerService.getAuthorizationHeaderOptions());
  }

  // Call uoload template API
  getUploadFiles(/*id: UserUploadDoc*/): Observable<any> {
    return this.httpsClient.post<UserUploadDoc>(
      this.API_URL + "profile/getuploads", null,
      this.headerService.getAuthorizationHeaderOptions());
  }

  getDownloadLink(theFile: UserUploadDoc): Observable<any> {
    return this.httpsClient.post<UserUploadDoc>(
      `${this.API_URL}profile/Download`, theFile, this.httpOptions);
  }

  getPDF2(theFile: string) {
    return this.httpsClient.get(`${this.API_URL}profile/Download2/${theFile}`, {
      responseType: "arraybuffer"
    });
  }

}
